import { Component,ViewChild, Input, SimpleChanges, ElementRef, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { LtmsWidgetToolsComponent } from '../../../../ltms-widget-tools/ltms-widget-tools.component';
import { NgIf, NgFor } from '@angular/common';
import { LtmsDoughnutChartViewComponent } from '../../../../graph/ltms-doughnut-chart-view/ltms-doughnut-chart-view.component';
import { LtmsLoaderComponent } from '../../../../ltms-loader/ltms-loader.component';
import { IndianNumberFormatPipe } from '../../../../../pipes/format-number/format-number.pipe';
// import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
// import { EngagementService } from 'src/app/shared/services/engagement/engagement.service';

@Component({
    selector: 'app-engagement-doughnut-chart',
    templateUrl: './engagement-doughnut-chart.component.html',
    styleUrl: './engagement-doughnut-chart.component.scss',
    imports: [LtmsWidgetToolsComponent, NgIf, LtmsDoughnutChartViewComponent, NgFor, LtmsLoaderComponent, IndianNumberFormatPipe]
})
export class EngagementDoughnutChartComponent {
  @Input() values: any;
  @Input() displayName: string = "";
  @Input() isDataLoaded: boolean = false;
  @ViewChild('attemptCard') attemptCard!: ElementRef;
  @ViewChild('channelCard') channelCard!: ElementRef;
  @ViewChild('deviceCard') deviceCard!: ElementRef;
  doughnutChartGraphDetails: string = 'Analyze response distribution by device, channel, and attempt. Understand user preferences and optimize your outreach strategies for better engagement.';
  isDataAvailable: boolean = false;
  chartData:any[] = [];
  attemptschartData:any[] = [];
  channelsData:any[] = [];
  attemptsData: any = []
  channelData: { name: string; number_of_user_rated: number, percentage: any }[] = [];
  chartDesktopPercentage: any;
  chartTabletPercentage: any;
  chartMobilePercentage: any;
  totalRecords: number = 0;
  topName: string = 'Mobile';
  midName: string = 'Tablet';
  bottomName: string = 'Desktop';
  topValue: string = '0';
  midValue: string = '0';
  bottomValue: string = '0';
  isTopData: boolean = false
  isMidData: boolean = false
  isBottomData: boolean = false
  dataUnavailableMessage: string = 'No data available for the current date range. Try changing the date range.'; // New flag to store the message
  attemptbackgroundColor: any = []
  devicebackgroundColor: any = []
  channelbackgroundColor: any = []
  doughnutChartConfig: any = {
    backgroundColor: ['#4681B4', '#DD9FDD', '#8B4513'],
  }

  widgetConfig: any = {
    //TODO
    "download": {
      enable: true,
      componentId: '',
      data: {
        "accountOrProjectName": '',
        "headers": [],
        "body": [],
        rows: [],
        columns: [
          {
            order: 1,
            header: "",
            dataKey: "name",
          },
          {
            order: 2,
            header: "",
            dataKey: "number_of_user_rated"
          },
          {
            order: 3,
            header: "",
            dataKey: "percentage"
          }
        ],
        title: "Response Distribution",
        fileName: "Response Distribution"
      }
    },
    "fullscreen": {
      enable: false,
      componentId: 'barChartId'
    }
  }
  constructor(private cdRef: ChangeDetectorRef) {}
  ngOnChanges(changes: SimpleChanges) {
    // console.log("changes['values'].currentValue",changes['values']);
    // console.log("changes['values'].currentValue",this.values);

    if (changes['values'] && changes['values'].currentValue) {
      let data = changes['values'].currentValue
      // let distributionData = changes['values'].currentValue.distributionData;
      if(data) {
        // this.prepareChartData(distributionData?.current);
        this.prepareChartData(data);
      }

    }
    this.checkCardHeight(this.channelCard, 'card');
    this.checkCardHeight(this.attemptCard, 'card');
  }

  rgbToHsl(r: number, g: number, b: number): { h: number, s: number, l: number } {
    r /= 255;
    g /= 255;
    b /= 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const diff = max - min;

    let h = 0;
    let s = 0;
    let l = (max + min) / 2;

    if (diff !== 0) {
      s = (l > 0.5) ? diff / (2 - max - min) : diff / (max + min);

      if (max === r) {
        h = (g - b) / diff + (g < b ? 6 : 0);
      } else if (max === g) {
        h = (b - r) / diff + 2;
      } else {
        h = (r - g) / diff + 4;
      }
      h *= 60;
    }

    return { h, s, l };
  }

  hslToRgb(h: number, s: number, l: number): { r: number, g: number, b: number } {
    let r = l;
    let g = l;
    let b = l;

    if (s !== 0) {
      const temp2 = (l < 0.5) ? l * (1 + s) : (l + s) - (l * s);
      const temp1 = 2 * l - temp2;
      r = this.hueToRgb(temp1, temp2, h + 120);
      g = this.hueToRgb(temp1, temp2, h);
      b = this.hueToRgb(temp1, temp2, h - 120);
    }

    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
  }

  hueToRgb(temp1: number, temp2: number, h: number): number {
    h = (h + 360) % 360;
    if (h < 60) return temp1 + (temp2 - temp1) * h / 60;
    if (h < 180) return temp2;
    if (h < 240) return temp1 + (temp2 - temp1) * (240 - h) / 60;
    return temp1;
  }

  createColorWithSlightAdjustment(index: number, data: any[], colorCode: string):string {
    const regex = /^rgba?\((\d+), (\d+), (\d+)/;
    const match = colorCode.match(regex);

    if (!match) {
      throw new Error("Invalid color code format. Please provide a valid RGB or RGBA color.");
    }

    let r = parseInt(match[1]);
    let g = parseInt(match[2]);
    let b = parseInt(match[3]);

    let { h, s, l } = this.rgbToHsl(r, g, b);

    h = (h + index * 20) % 360;  // Adjust the hue by a fixed amount

    // Keep saturation and lightness in a moderate range
    s = Math.min(0.8, Math.max(0.5, s));  // Moderate saturation
    l = Math.min(0.7, Math.max(0.4, l));  // Moderate lightness

    // Convert back to RGB
    const rgb = this.hslToRgb(h, s, l);
    return `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`;
  };
  
  generateColors(data: any[], colorCode: string):string[] {
    return data
      .map((_, index) => this.createColorWithSlightAdjustment(index, data, colorCode))
  };

  prepareChartData(response) {
    if (response?.current?.doc_count > 0) {
      // Existing logic to process data
      this.isDataAvailable = true;
      // this.dataUnavailableMessage = ''; // Clear the message when data is available
    } else {
      // No data available
      this.isDataAvailable = false;
      this.dataUnavailableMessage = 'No data available for the current date range. Try changing the date range.'; // Set the message
      this.resetChartData(); // Reset chart data
    }
    let currentTopValue: any;
    let currentMidValue: any;
    let currentBottomValue: any;
    this.topName = 'Mobile';
    this.midName = 'Tablet';
    this.bottomName = 'Desktop';
    this.channelsData = [];
    this.attemptsData = [];
    this.chartData = [];
    this.channelData = [];
    this.attemptschartData = [];
    let mediumsDownloadData = [{"name": "Medium", "number_of_user_rated": "Count", "percentage": "Percentage"}]
    let channelsDownloadData = [{},{"name": "Channel", "number_of_user_rated": "Count", "percentage": "Percentage"}]
    let trialsDownloadData = [{},{"name": "Trial", "number_of_user_rated": "Count", "percentage": "Percentage"}]
    

    if (response?.current?.doc_count>0) {
    //prepare attempt data
    if (response && response.current.response_by_attempt && !_.isEmpty(response.current.response_by_attempt)) {
      this.attemptsData = [];
      const attempts: { [key: string]: number } = {};
      let totalRatedByAttempts = 0;

      // First loop to aggregate counts
      _.each(response.current.response_by_attempt, (value, key) => {
        key = (_.isEmpty(key)) ? "1" : key;
        if (key && key !== "") {
          const field = "Attempt " + key;
          let count = 0;

          // Sum counts from attempt_channels
          if (value && value.attempt_channels && !_.isEmpty(value.attempt_channels)) {
            _.each(value.attempt_channels, (channelData) => {
              count += channelData.count;
            });
          }

          // Update attempts object
          if (!attempts[key]) {
            attempts[key] = count;
          } else {
            attempts[key] += count;
          }

          totalRatedByAttempts += attempts[key]; // Update total
        }
      });

      // Second loop to prepare attemptsData
      _.each(attempts, (count, key) => {
        const field = "Attempt " + key;
        if (count) {
          const percentage = ((count / totalRatedByAttempts) * 100).toFixed(1);
          this.attemptsData.push({ name: field, number_of_user_rated: count, percentage: percentage + " %" });
        }
      });
      trialsDownloadData.push(... this.attemptsData);
      // Assign to attemptschartData once
      this.attemptschartData = this.attemptsData.map(item => ({
        key: item.name,
        value: item.number_of_user_rated
      }));
    }

    //prepare Device data
    currentTopValue = response?.current?.rated_from_mobile ? response.current.rated_from_mobile : 0
    currentMidValue = response?.current?.rated_from_tablet ? response.current.rated_from_tablet : 0
    currentBottomValue = response?.current?.rated_from_desktop ? response.current.rated_from_desktop : 0
    let totalDeviceValue = currentTopValue + currentMidValue + currentBottomValue
    this.chartMobilePercentage = totalDeviceValue > 0 ? ((currentTopValue / totalDeviceValue) * 100).toFixed(1) + " %" : "0.0 %"
    this.chartTabletPercentage = totalDeviceValue > 0 ? ((currentMidValue / totalDeviceValue) * 100).toFixed(1) + " %" : "0.0 %"
    this.chartDesktopPercentage = totalDeviceValue > 0 ? ((currentBottomValue / totalDeviceValue) * 100).toFixed(1) + " %" : "0.0 %"
    if (currentTopValue || currentMidValue || currentBottomValue) {
      this.chartData = [{ key: this.topName, value: currentTopValue }, { key: this.midName, value: currentMidValue }, { key: this.bottomName, value: currentBottomValue }];
    }
    this.topValue = response.current.rated_from_mobile;
    if (this.topValue) {
      this.isTopData=true
    }
    this.midValue = response.current.rated_from_tablet;
    if (this.midValue) {
      this.isMidData=true
    }
    this.bottomValue = response.current.rated_from_desktop;
    if (this.bottomValue) {
      this.isBottomData=true
    }
    mediumsDownloadData.push(...[
      { "name": this.topName, "number_of_user_rated": this.topValue, percentage: this.chartMobilePercentage },
      { "name": this.midName, "number_of_user_rated": this.midValue, percentage: this.chartTabletPercentage },
      { "name": this.bottomName, "number_of_user_rated": this.bottomValue, percentage: this.chartDesktopPercentage }
    ])
    //prepare channels data
    if (response.current && response.current.response_by_channel_overall && !_.isEmpty(response.current.response_by_channel_overall)) {
      this.channelData = []; // Ensure channelData is reset
      let totalRatedByChannels = 0;

      // Define the mapping outside the loop for better performance
      const mapping = {
        "sms": "SMS",
        "email": "Email",
        "link": "Link",
        "whatsapp": "WhatsApp",
        "qrcode": "QR Code",
        "kiosk_link": "Kiosk Link",
        "all": "All"
      };

      // First loop to calculate the total count
      _.each(response.current.response_by_channel_overall, (value, key) => {
        if (key && key !== "") {
          const count = (value && value.count) ? value.count : 0; // Fallback to 0 if count is undefined
          totalRatedByChannels += count; // Increment total rated channels
        }
      });

      // Second loop to populate channelData with percentages
      _.each(response.current.response_by_channel_overall, (value, key) => {
        if (key && key !== "") {
          const count = (value && value.count) ? value.count : 0; // Fallback to 0 if count is undefined
          key = mapping[key] || key; // Map key or use original

          // Calculate percentage using the total from the first loop
          const percentage = totalRatedByChannels > 0 ? ((count / totalRatedByChannels) * 100).toFixed(1) : '0.0 %';

          this.channelData.push({ name: key, number_of_user_rated: count, percentage: percentage + " %" });
          channelsDownloadData.push({ name: key, number_of_user_rated: count, percentage: percentage + " %" })
        }
      });
      this.widgetConfig['download']['data']['rows'] =[...mediumsDownloadData,...channelsDownloadData,...trialsDownloadData]
      if (this.displayName && this.displayName.trim() != ""){
        this.widgetConfig['download']['data']['title'] = "Response Distribution - " + this.displayName; 
      }
      // Assign channelsData once after processing
      this.channelsData = this.channelData.map(item => ({
        key: item.name,
        value: item.number_of_user_rated
      }));
    }
    if (response && response.current && (response.current.doc_count != 0 || response.current.doc_count != '0')) {
      this.isDataAvailable = true;
    }
    this.attemptbackgroundColor = this.generateColors(this.attemptsData,"rgba(240, 95, 34, 0.9)");
    this.devicebackgroundColor = this.generateColors(this.chartData,"rgba(0, 59, 54, 1)");
    this.channelbackgroundColor = this.generateColors(this.channelData,"rgba(154, 23, 154, 1)");
  } else {
    // this.isDataAvailable = false;
    this.attemptsData = [];
    this.attemptschartData=[]
    this.channelData = [];
    this.chartData = []
    this.isBottomData= false
    this.isMidData=false
    this.isTopData=false
  }
  }
  checkCardHeight(card: ElementRef, className: string) {
    const height = card?.nativeElement?.offsetHeight;
    const baseHeight = this.deviceCard?.nativeElement?.offsetHeight;
    if (height > baseHeight) {
      card.nativeElement.className = className + ' bottom-border-radius'; 
    }
    this.cdRef.detectChanges();
  }
  resetChartData() {
    this.chartData = [];
    this.attemptsData = [];
    this.attemptschartData = [];
    this.channelData = [];
    this.channelsData = [];
    this.isBottomData = false;
    this.isMidData = false;
    this.isTopData = false;
  }
}
